import React from 'react';
import { CheckIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { SocialProofPopup } from '../components/SocialProofPopup';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/4s8zBW24WduhRTbNcR5GEJ/Mockup_-_Fisico_Visible.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/2uyc8vhgWQuvM9EerQ1m9N/Mockup_-_Bono_1.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/pjBNgUGYL2kQBCRqExtCKQ/Mockup_-_Bono_2.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/3b3uFY4fkgm7aCeEkYvvsM/Mockup_-_Bono_3.png';
const CHECKOUT_LINK = 'https://checkout.tumundoglobal.online/cart/45196290228415:1';
const SECTION_LINK = '#compra';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20" data-id="element-34">
      <CountdownTimer data-id="element-35" />
      <SocialProofPopup data-id="element-36" />

      {/* HERO SECTION */}
      <section className="pt-8 pb-12 px-4 md:pt-12 md:pb-20 bg-gradient-to-b from-white to-gray-50" data-id="element-37">
        <div className="max-w-4xl mx-auto text-center" data-id="element-38">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-700 px-6 py-2 rounded-full mb-6" data-id="element-39">
            <span className="text-sm md:text-base font-medium uppercase tracking-wide" data-id="element-40">
              💪 PARA HOMBRES QUE ENTRENAN Y QUIEREN QUE SE NOTE
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-black tracking-tight text-gray-900 mb-8 leading-tight" data-id="element-41">
            Lográ definición real en menos de 30 días sin improvisar tus
            comidas.
          </h1>

          <div className="mb-6" data-id="element-42">
            <a href={SECTION_LINK} data-id="element-43">
              <img src={PRODUCT_IMAGE} alt="MegaPack Físico Visible" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-44" />
            </a>
          </div>

          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-45">
            Organizá tu semana en 30 minutos, reducí delivery y acompañá tu
            entrenamiento con{' '}
            <span className="bg-yellow-300 px-1" data-id="element-46">
              estructura real sin gastar de más.
            </span>
          </p>

          <CTAButton data-id="element-47">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-50">
            Si entrenás pero comés cualquier cosa, estás desperdiciando
            esfuerzo.
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-51">
            <p className="font-medium" data-id="element-52">Entrenás. Transpirás. Metés peso.</p>
            <p className="font-medium" data-id="element-53">Pero el espejo no cambia.</p>
            <p className="font-medium" data-id="element-54">
              No te marcás. No subís masa limpia. No definís.
            </p>
            <p className="font-medium" data-id="element-55">Y el problema no es el gimnasio.</p>
            <p className="font-medium" data-id="element-56">Es que estás improvisando la comida.</p>

            <p className="text-center font-bold text-2xl mt-8 border-l-4 border-[#dc2626] pl-4 py-2 bg-red-50" data-id="element-57">
              Sin estructura en la alimentación, el entrenamiento no alcanza.
            </p>
          </div>

          <div className="mt-12" data-id="element-58">
            <CTAButton data-id="element-59">👉 QUIERO TERMINAR CON ESTA CONFUSIÓN</CTAButton>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-60">
        <div className="max-w-4xl mx-auto" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-yellow-400" data-id="element-62">
            El problema que nadie quiere aceptar
          </h2>

          <div className="flex flex-col gap-6 max-w-3xl mx-auto" data-id="element-63">
            {/* Card 1 */}
            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-64">
              <ul className="space-y-3" data-id="element-65">
                <li className="flex items-start gap-3 text-gray-200" data-id="element-66">
                  <span className="text-gray-500 mt-1" data-id="element-67">•</span>
                  <span className="text-lg font-medium" data-id="element-68">
                    Trabajás o estudiás 8–9 horas.
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-200" data-id="element-69">
                  <span className="text-gray-500 mt-1" data-id="element-70">•</span>
                  <span className="text-lg font-medium" data-id="element-71">
                    Entrenás después del laburo.
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-200" data-id="element-72">
                  <span className="text-gray-500 mt-1" data-id="element-73">•</span>
                  <span className="text-lg font-medium" data-id="element-74">Comés lo que hay.</span>
                </li>
                <li className="flex items-start gap-3 text-gray-200" data-id="element-75">
                  <span className="text-gray-500 mt-1" data-id="element-76">•</span>
                  <span className="text-lg font-medium" data-id="element-77">
                    Pedís delivery 2 o 3 veces por semana.
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-200" data-id="element-78">
                  <span className="text-gray-500 mt-1" data-id="element-79">•</span>
                  <span className="text-lg font-medium" data-id="element-80">
                    Comprás proteína… pero sin estructura.
                  </span>
                </li>
              </ul>
            </div>

            {/* Card 2 */}
            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-81">
              <p className="text-2xl font-bold italic text-gray-300 mb-6" data-id="element-82">
                "¿Por qué me veo igual?"
              </p>
              <p className="text-lg font-bold text-white mb-6" data-id="element-83">
                La realidad es simple: Sin sistema de alimentación, no hay
                físico visible.
              </p>
              <div className="space-y-2 font-bold text-red-400 text-xl mb-6" data-id="element-84">
                <p data-id="element-85">❌ No es que no entrenes fuerte.</p>
                <p data-id="element-86">❌ No es que no tengas disciplina.</p>
                <p data-id="element-87">❌ No es que tu genética sea mala.</p>
              </div>
              <p className="text-gray-300 text-lg" data-id="element-88">
                Es que no tenés estructura ejecutable. Y sin estructura, el
                progreso es suerte.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-gray-800 p-8 rounded-xl border border-gray-700" data-id="element-89">
              <h3 className="text-xl font-bold text-red-400 mb-4" data-id="element-90">
                Tu problema no es el entrenamiento.
              </h3>
              <p className="text-gray-300 text-lg mb-3" data-id="element-91">
                Es no tener un sistema de alimentación ejecutable.
              </p>
              <p className="text-gray-300 text-lg" data-id="element-92">
                Y nadie te lo entregó así.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-93">
            <p className="text-2xl font-bold text-[#22c55e]" data-id="element-94">
              👉 MegaPack · Físico Visible nace para eliminar esa improvisación.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-95">
        <div className="max-w-5xl mx-auto" data-id="element-96">
          <div className="text-center mb-16" data-id="element-97">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-98">
              ✅ LA SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-6 mb-4" data-id="element-99">
              MegaPack · Físico Visible
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-100">
              El sistema completo de alimentación práctica para hombres que
              entrenan en Argentina.
            </p>
            <p className="text-lg text-gray-500 mt-3 max-w-2xl mx-auto" data-id="element-101">
              No es una dieta. No es teoría. No es nutrición clínica.{' '}
              <strong data-id="element-102">Es estructura aplicable.</strong>
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-103">
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-104">
              <h3 className="text-2xl font-bold mb-6" data-id="element-105">
                Diseñado para que puedas:
              </h3>
              <ul className="space-y-4" data-id="element-106">
                <li className="flex items-center gap-3" data-id="element-107">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-108" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-109">
                    Organizar tu alimentación semanal en menos de 30 minutos
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-110">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-111" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-112">
                    Reducir delivery innecesario
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-113">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-114" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-115">
                    Ahorrar 15–25% en comida mensual
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-116">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-117" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-118">
                    Ver cambios físicos visibles en 6–8 semanas
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-119">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-120" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-121">
                    Dejar de entrenar "al pedo"
                  </span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col justify-center items-center text-center p-8 bg-gray-50 rounded-2xl border border-gray-100" data-id="element-122">
              <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-123">
                Cómo funciona:
              </h3>
              <div className="space-y-6 text-xl font-bold text-gray-800" data-id="element-124">
                <div className="flex items-start gap-4" data-id="element-125">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-126">
                    1
                  </span>
                  <span className="text-left" data-id="element-127">
                    Abrís el tomo según tu objetivo
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-128">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-129">
                    2
                  </span>
                  <span className="text-left" data-id="element-130">
                    Ajustás gramos con la regla simple
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-131">
                  <span className="w-8 h-8 bg-black text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-1" data-id="element-132">
                    3
                  </span>
                  <span className="text-left" data-id="element-133">
                    Ejecutás la semana sin improvisar
                  </span>
                </div>
              </div>
              <p className="mt-8 text-lg text-gray-600 italic" data-id="element-134">
                Sin vueltas. Sin teoría innecesaria. Solo ejecución.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-135">👉 QUIERO EMPEZAR ESTA SEMANA</CTAButton>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-136">
        <div className="max-w-5xl mx-auto" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-138">
            📦 ¿Qué incluye el MegaPack Físico Visible?
          </h2>
          <p className="text-center text-xl text-gray-600 mb-12" data-id="element-139">
            📕 6 TOMOS DEL SISTEMA FÍSICO VISIBLE
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-141">
              <div className="text-4xl mb-4" data-id="element-142">📕</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-143">
                Tomo 1 — Definición Inteligente
              </h3>
              <p className="text-gray-600" data-id="element-144">
                4 semanas estructuradas para bajar grasa sin perder músculo, con
                guía de extensión a 8 semanas.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-145">
              <div className="text-4xl mb-4" data-id="element-146">📗</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-147">
                Tomo 2 — Volumen Limpio
              </h3>
              <p className="text-gray-600" data-id="element-148">
                Sistema de superávit controlado para ganar masa muscular sin
                acumular grasa innecesaria.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-149">
              <div className="text-4xl mb-4" data-id="element-150">📘</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-151">
                Tomo 3 — Meal Prep de Rendimiento
              </h3>
              <p className="text-gray-600" data-id="element-152">
                Cociná 2 veces por semana y resolvé 7 días completos sin
                improvisar ni pedir delivery.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-153">
              <div className="text-4xl mb-4" data-id="element-154">📙</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-155">
                Tomo 4 — Desayunos y Snacks de Gimnasio
              </h3>
              <p className="text-gray-600" data-id="element-156">
                Opciones rápidas (≤5 min) con proteína clara para asegurar 60g
                antes del mediodía.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-157">
              <div className="text-4xl mb-4" data-id="element-158">📓</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-159">
                Tomo 5 — Fitness Económico Argentino
              </h3>
              <p className="text-gray-600" data-id="element-160">
                Estrategias reales para mantener proteína alta sin gastar de más
                en contexto de inflación.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-161">
              <div className="text-4xl mb-4" data-id="element-162">📒</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-163">
                Tomo 6 — Sistema Completo 30 Días
              </h3>
              <p className="text-gray-600" data-id="element-164">
                Plan estructurado día por día con ajustes, seguimiento y reglas
                claras para progresar sin fricción.
              </p>
            </a>
          </div>

          <div className="mt-12 bg-white p-6 rounded-xl border border-gray-200 max-w-3xl mx-auto" data-id="element-165">
            <ul className="space-y-3 text-lg" data-id="element-166">
              <li className="flex items-center gap-3" data-id="element-167">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-168" />
                <span className="font-medium" data-id="element-169">
                  Más de 6 tomos especializados
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-170">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-171" />
                <span className="font-medium" data-id="element-172">Organizados por objetivo</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-173">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-174" />
                <span className="font-medium" data-id="element-175">Con regla de ajuste simple</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-176">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-177" />
                <span className="font-medium" data-id="element-178">
                  Sin contar calorías obsesivamente
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-179">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-180" />
                <span className="font-medium" data-id="element-181">Con meal prep incluido</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-182">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-183" />
                <span className="font-medium" data-id="element-184">
                  Pensado para el contexto argentino
                </span>
              </li>
            </ul>
          </div>

          <p className="text-center text-lg font-medium mt-12 text-gray-700" data-id="element-185">
            👉 Todo estructurado para que sepas qué comer y cuándo hacerlo.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-188">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-189">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-190">
              <h3 className="text-xl font-bold text-red-800 mb-6 text-center" data-id="element-191">
                Antes de Físico Visible
              </h3>
              <ul className="space-y-4" data-id="element-192">
                <li className="flex items-center gap-3" data-id="element-193">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-194" />
                  <span className="text-gray-700" data-id="element-195">Improvisás comidas</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-196">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-197" />
                  <span className="text-gray-700" data-id="element-198">Delivery frecuente</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-199">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-200" />
                  <span className="text-gray-700" data-id="element-201">Proteína insuficiente</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-202">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-203" />
                  <span className="text-gray-700" data-id="element-204">Peso estancado</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-205">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-206" />
                  <span className="text-gray-700" data-id="element-207">
                    Entrenamiento sin resultados visibles
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-208">
              <h3 className="text-xl font-bold text-green-800 mb-6 text-center" data-id="element-209">
                Después de Físico Visible
              </h3>
              <ul className="space-y-4" data-id="element-210">
                <li className="flex items-center gap-3" data-id="element-211">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-212" />
                  <span className="font-bold text-gray-800" data-id="element-213">
                    Semana organizada
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-214">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-215" />
                  <span className="font-bold text-gray-800" data-id="element-216">
                    Compras estratégicas
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-217">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-218" />
                  <span className="font-bold text-gray-800" data-id="element-219">
                    Proteína cubierta
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-220">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-221" />
                  <span className="font-bold text-gray-800" data-id="element-222">
                    Déficit o superávit controlado
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-223">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-224" />
                  <span className="font-bold text-gray-800" data-id="element-225">
                    Cambios visibles en 6–8 semanas
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#0f172a] text-white" data-id="element-226">
        <div className="max-w-5xl mx-auto" data-id="element-227">
          <div className="text-center mb-12" data-id="element-228">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-229">
              🎁 BONOS PREMIUM GRATIS – INCLUIDOS HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-4" data-id="element-230">
              ¡GRATIS POR HOY!
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-231">
            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-232">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-233">
                <img src={BONUS_1_IMAGE} alt="Bono 1 - Guía de Supermercado Inteligente" className="w-full h-full object-contain drop-shadow-xl" data-id="element-234" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-235">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-236">
                🎁 Bono 1 – Guía de Supermercado Inteligente
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-237">
                Cómo comprar proteína suficiente sin regalar plata.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-238">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-239">
                <img src={BONUS_2_IMAGE} alt="Bono 2 - Manual de Salidas y Vida Social" className="w-full h-full object-contain drop-shadow-xl" data-id="element-240" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-241">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-242">
                🎁 Bono 2 – Manual de Salidas y Vida Social
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-243">
                Qué hacer en asados y fines de semana sin sabotear resultados.
              </p>
            </a>

            <a href={SECTION_LINK} className="bg-[#1e293b] rounded-xl p-6 border border-[#334155] flex flex-col items-center text-center hover:border-yellow-400 transition-colors cursor-pointer" data-id="element-244">
              <div className="w-full aspect-square max-w-[270px] mb-6 flex items-center justify-center rounded-lg bg-[#1e293b]" data-id="element-245">
                <img src={BONUS_3_IMAGE} alt="Bono 3 - Sistema de Progreso Visual y Medición Profesional" className="w-full h-full object-contain drop-shadow-xl" data-id="element-246" />
              </div>
              <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-247">
                GRATIS HOY
              </span>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-248">
                🎁 Bono 3 – Sistema de Progreso Visual y Medición Profesional
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-249">
                Cómo medir cambios reales sin depender del espejo.
              </p>
            </a>
          </div>

          <div className="mt-12 text-center space-y-2 text-lg font-medium" data-id="element-250">
            <p data-id="element-251">👉 Los tomos te dan estructura.</p>
            <p data-id="element-252">👉 Los bonos evitan que pierdas progreso.</p>
            <p className="text-yellow-400 font-bold text-xl mt-4" data-id="element-253">
              Eso es lo que hace que funcione.
            </p>
          </div>

          <div className="mt-12" data-id="element-254">
            <CTAButton data-id="element-255">QUIERO MIS BONOS AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* OFFER STACK SECTION */}
      <section id="compra" className="py-16 px-4 bg-gradient-to-b from-gray-900 to-gray-800" data-id="element-256">
        <div className="max-w-4xl mx-auto" data-id="element-257">
          <div className="text-center mb-10" data-id="element-258">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide animate-pulse inline-block mb-4" data-id="element-259">
              ⏰ OFERTA ESPECIAL – Tiempo Limitado
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-tight" data-id="element-260">
              POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-261">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-262">
              📦 Lo que recibís hoy:
            </h3>

            <div className="space-y-4 mb-10" data-id="element-263">
              <div className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-264">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-265" />
                <span className="font-bold text-gray-800" data-id="element-266">
                  6 Tomos completos del sistema Físico Visible
                </span>
              </div>
              <div className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-267">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-268" />
                <span className="font-bold text-gray-800" data-id="element-269">3 Bonos Premium</span>
              </div>
              <div className="flex items-center gap-3 text-lg md:text-xl border-b border-gray-200 pb-3" data-id="element-270">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-271" />
                <span className="font-bold text-gray-800" data-id="element-272">
                  Acceso digital inmediato
                </span>
              </div>
              <div className="flex items-center gap-3 text-lg md:text-xl" data-id="element-273">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-274" />
                <span className="font-bold text-gray-800" data-id="element-275">
                  Acceso de por vida
                </span>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-276">
              <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-277">
                Precio regular: <span className="line-through" data-id="element-278">49.990 ARS</span>
              </p>
              <div className="flex items-center justify-center gap-3" data-id="element-279">
                <span className="text-5xl" data-id="element-280">🔥</span>
                <span className="text-5xl md:text-6xl font-black text-[#22c55e] leading-none" data-id="element-281">
                  19.990 ARS
                </span>
              </div>
              <p className="text-gray-500 font-medium mt-2 text-sm" data-id="element-282">
                Un solo pago. Sin suscripciones.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center w-full" data-id="element-283">
              <a href={CHECKOUT_LINK} className="relative group flex items-center justify-center gap-2 w-full md:max-w-2xl px-6 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1 text-xl md:text-2xl font-bold uppercase tracking-normal" data-id="element-284">
                👉 OBTENER MI MEGAPACK AHORA
              </a>
            </div>
          </div>

          <div className="mt-10 flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-285">
            <ShieldCheckIcon className="w-16 h-16 text-yellow-400 flex-shrink-0" data-id="element-286" />
            <div className="text-center md:text-left" data-id="element-287">
              <h3 className="text-xl font-bold mb-2 text-white" data-id="element-288">
                Garantía de 30 días sin riesgo
              </h3>
              <p className="text-gray-300" data-id="element-289">
                Probalo durante 30 días. Si no sentís que el sistema te dio
                estructura real, podés pedir reembolso. Sin vueltas. Sin
                preguntas innecesarias.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW PAGES SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-290">
        <div className="max-w-4xl mx-auto" data-id="element-291">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-292">
            📖 Revisá algunas hojas
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-293">
            Mirá una muestra real del contenido.
          </p>

          {/* Empty placeholder — images to be added later */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-294">
            <div className="bg-gray-100 rounded-2xl aspect-[3/4] flex items-center justify-center" data-id="element-295">
              <p className="text-gray-400 text-sm font-medium" data-id="element-296">Próximamente</p>
            </div>
            <div className="bg-gray-100 rounded-2xl aspect-[3/4] flex items-center justify-center" data-id="element-297">
              <p className="text-gray-400 text-sm font-medium" data-id="element-298">Próximamente</p>
            </div>
            <div className="bg-gray-100 rounded-2xl aspect-[3/4] flex items-center justify-center" data-id="element-299">
              <p className="text-gray-400 text-sm font-medium" data-id="element-300">Próximamente</p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-301">
        <div className="max-w-6xl mx-auto" data-id="element-302">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-303">
            Lo que dicen los que ya lo tienen
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-304">
            <TestimonialCard name="Matías" age={24} location="Buenos Aires" quote="Llevaba 2 años entrenando y el espejo no cambiaba. Con el sistema de Físico Visible organicé mi alimentación en una semana. En 6 semanas ya se notaba la diferencia." data-id="element-305" />
            <TestimonialCard name="Nicolás" age={28} location="Córdoba" quote="Pedía delivery 3 veces por semana y compraba proteína sin estructura. El Tomo 3 de Meal Prep me cambió todo. Cocino 2 veces y resuelvo la semana." data-id="element-306" />
            <TestimonialCard name="Rodrigo" age={31} location="Rosario" quote="Siempre creí que necesitaba un nutricionista caro. Esto es más práctico y ejecutable. En 8 semanas bajé 5 kilos de grasa sin perder fuerza." data-id="element-307" />
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-308">
            <TestimonialCard name="Facundo" age={26} location="Mendoza" quote="El tomo de Fitness Económico vale oro. Con la inflación que hay, aprendí a mantener proteína alta sin gastar el doble. Ahorro 20% por mes." data-id="element-309" />
            <TestimonialCard name="Tomás" age={22} location="La Plata" quote="Soy estudiante, no tengo tiempo. Los desayunos y snacks de 5 minutos me aseguran proteína antes del mediodía. Simple y efectivo." data-id="element-310" />
            <TestimonialCard name="Ezequiel" age={33} location="Santa Fe" quote="Entrenaba hace 4 años y nunca definí de verdad. Con el Tomo 1 de Definición Inteligente, en 30 días ya vi cambios que nunca había logrado antes." data-id="element-311" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-312">
        <div className="max-w-3xl mx-auto" data-id="element-313">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-314">
            Preguntas frecuentes
          </h2>
          <FAQAccordion data-id="element-315" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-316">
        <div className="max-w-3xl mx-auto" data-id="element-317">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-318">
            Si entrenás, que se vea.
          </h2>
          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-319">
            No necesitás más motivación. No necesitás otro pre entreno.
          </p>

          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-320">
            Necesitás sistema.
          </p>

          <p className="text-2xl text-white font-bold mb-10" data-id="element-321">
            Organizá tu alimentación esta semana. Empezá a progresar.
          </p>

          <a href={SECTION_LINK} className="inline-flex flex-col items-center justify-center px-12 py-5 md:py-6 bg-[#22c55e] hover:bg-[#16a34a] text-white text-center rounded-xl shadow-xl hover:shadow-2xl transform transition-all duration-200 hover:-translate-y-1 border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1" data-id="element-322">
            <span className="text-lg md:text-xl font-bold uppercase tracking-normal" data-id="element-323">
              👉 ACCEDÉ AHORA AL MEGAPACK FÍSICO VISIBLE
            </span>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-black text-gray-500 text-center text-sm" data-id="element-324">
        <p data-id="element-325">© 2024 MegaPack Físico Visible. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-326">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}